import { Component, OnInit } from '@angular/core';
import { Login, LoginResponse } from '../models/login';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../Services/api-service';
import { SharedService } from '../Services/shared-service.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  show:boolean=false;
  formval:Login=new Login();
  constructor(private sharedService: SharedService,private service:ApiService, private router: Router,private toastr: ToastrService) { }

  ngOnInit() {
  }

  onSubmit()
  {

  this.show=true;

  this.service.PostApiLogin(this.formval,"Login/LoginAuth").subscribe((response: any) => {
    if(response.ResponseCode=="200")
    {
      this.show=false;
      sessionStorage.setItem("log","log")
      sessionStorage.setItem("token",response.ResponseData.Tokan)
      localStorage.setItem("name",response.ResponseData.UserData.FirstName+" "+response.ResponseData.UserData.LastName)
      localStorage.setItem("userID",response.ResponseData.UserData.ID);
      localStorage.setItem("Mobile",response.ResponseData.UserData.Mobile);
      localStorage.setItem("usertype",response.ResponseData.UserData.UserType)
      localStorage.setItem("organisation",response.ResponseData.UserData.Organisation)
      localStorage.setItem("organisationname",response.ResponseData.OrganisationName)
      localStorage.setItem("UsrGroup",response.ResponseData.UserData.UsrGroup)
      this.sharedService.refreshNavBar();
    }
    else
    {

      this.show=false;
       this.toastr.warning( response.ResponseMessage,'Error!',{
         timeOut:3000

        });
    }


  },err => {

    this.show=false;
    this.toastr.warning('Please enter valid credentials','Warning!',{
      timeOut:3000

     });

  })}

}
